import XSnackbar from './XSnackbar'
export default XSnackbar
